module.exports = __webpack_public_path__ + "img/6532.9aa465ae.jpg";